import React, { useState } from 'react';
import { Send, Lightbulb, CheckCircle, MessageSquare } from 'lucide-react';
import emailjs from "@emailjs/browser"

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    idea: ''
  });
  const [status, setStatus] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const SERVICE_ID = "service_zivt9cs"
    const TEMPLATE_ID = "template_y385zo7" 
    const PUBLIC_KEY = "lWHjXF72fo_-hjQ3X" 

    const templateParams = {
        name: formData.name,
        email: formData.email,
        idea: formData.idea,
        to_email: "tszhudf@gmail.com"
    }

    try {
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY)
      
      setStatus("success")
      setSubmitted(true);
      
      // Reset form
      setFormData({ name: '', email: '', idea: '' });
    } catch (error) {
          console.error('Error sending email:', error);
          setStatus("error");
    };
    
    // Reset success message after 5 seconds (optional, but good UX if they want to submit another)
    // setTimeout(() => setSubmitted(false), 5000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8 md:py-12">
      <div className="grid md:grid-cols-2 gap-8 md:gap-12">
        
        {/* Left Side: Info */}
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-4">Have a Game Idea?</h1>
            <p className="text-gray-600 text-lg leading-relaxed">
              We're always looking for new ways to make math fun! If you have a favorite math game or a puzzle you'd like to see, let us know.
            </p>
          </div>

          <div className="bg-blue-50 p-6 rounded-xl border border-blue-100 hidden md:block">
            <h3 className="flex items-center gap-2 font-bold text-blue-800 mb-3">
              <Lightbulb className="w-5 h-5" />
              What we're looking for:
            </h3>
            <ul className="space-y-2 text-blue-700 text-sm">
               <li className="flex items-start gap-2">
                 <span className="mt-1">•</span> Strategy games with simple rules but deep logic.
               </li>
               <li className="flex items-start gap-2">
                 <span className="mt-1">•</span> Puzzles that visualize mathematical concepts.
               </li>
               <li className="flex items-start gap-2">
                 <span className="mt-1">•</span> Two-player games that encourage friendly competition.
               </li>
            </ul>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-gray-100">
           {!submitted ? (
             <form onSubmit={handleSubmit} className="space-y-5">
               <div>
                 <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                 <input 
                   type="text" 
                   id="name"
                   name="name"
                   required
                   className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                   placeholder="Your Name"
                   value={formData.name}
                   onChange={handleChange}
                 />
               </div>
               
               <div>
                 <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email <span className="text-gray-400 font-normal">(Optional)</span></label>
                 <input 
                   type="email" 
                   id="email"
                   name="email"
                   className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                   placeholder="you@example.com"
                   value={formData.email}
                   onChange={handleChange}
                 />
               </div>

               <div>
                 <label htmlFor="idea" className="block text-sm font-medium text-gray-700 mb-1">Your Game Idea</label>
                 <textarea 
                   id="idea"
                   name="idea"
                   required
                   rows="5"
                   className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none"
                   placeholder="Describe the game rules or concept..."
                   value={formData.idea}
                   onChange={handleChange}
                 ></textarea>
               </div>

               <button 
                 type="submit" 
                 className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 transition-transform active:scale-95 shadow-md hover:shadow-lg"
               >
                 <Send className="w-5 h-5" />
                 Send Idea
               </button>
             </form>
           ) : (
             <div className="h-full flex flex-col justify-center items-center text-center py-12 animate-fade-in">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6">
                  <CheckCircle className="w-8 h-8" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-2">Thank You!</h3>
                <p className="text-gray-600 mb-8">
                  Your idea has been sent to our team. We love hearing from our players!
                </p>
                <button 
                  onClick={() => setSubmitted(false)}
                  className="text-blue-600 font-medium hover:text-blue-800 underline flex items-center gap-1"
                >
                  <MessageSquare className="w-4 h-4" />
                  Send another idea
                </button>
             </div>
           )}
        </div>

      </div>
    </div>
  );
};

export default Contact;
